(function () {
    const lightboxInitted = [];

    const nextPagesHandled = [];

    const nextPage = (page, component) => {
        if (nextPagesHandled.find((p) => p === page)) {
            return;
        }

        nextPagesHandled.push(page);

        const nextButton = component.node.parentElement.querySelector(
            '.shopify-buy__collection-pagination-button',
        );

        setTimeout(() => {
            if (
                (nextButton && nextButton.offsetWidth, nextButton.offsetHeight)
            ) {
                nextButton.click();
            }
        }, 500);
    };

    const fixCarouselElement = (component) => {
        const carouselEl = component.view.wrapper.querySelector(
            '.shopify-buy__product-img-wrapper:nth-child(2)',
        );

        if (component.model.images.length === 1) {
            // Hide the carousel element, there's only one image
            carouselEl.style.display = 'none';
            return;
        }

        component.view.wrapper.querySelector(
            '.shopify-buy__product-img-wrapper',
        ).style.display = 'none';
        carouselEl.style.paddingTop = 0;
        carouselEl.style.position = 'relative';
        carouselEl.style.height = 'auto';
        carouselEl.style.marginBottom = '15px';

        const mainImageEl = carouselEl.querySelector(
            '.main-image-wrapper .shopify-buy__product__variant-img',
        );

        const newWrapper = document.createElement('div');

        newWrapper.classList.add('custom-carousel-image-wrapper');

        carouselEl.querySelector('.main-image-wrapper').prepend(newWrapper);

        newWrapper.appendChild(mainImageEl);

        newWrapper.style.paddingTop = 'calc(75% + 15px)';
        newWrapper.style.position = 'relative';
        newWrapper.style.height = '0';

        const multiplyImageBy = 3;

        mainImageEl.src = mainImageEl.src.replace(
            '_280x420',
            `_${280 * multiplyImageBy}x${420 * multiplyImageBy}`,
        );

        const observer = new MutationObserver((changes) => {
            changes.forEach((change) => {
                if (change.attributeName.includes('src')) {
                    if (mainImageEl.src.indexOf('_280x420') > -1) {
                        mainImageEl.src = mainImageEl.src.replace(
                            '_280x420',
                            '_560x840',
                        );
                    }
                }
            });
        });

        observer.observe(mainImageEl, {
            attributes: true,
        });

        // Fix thumbnails

        component.view.wrapper
            .querySelectorAll('.shopify-buy__carousel-item ')
            .forEach((el) => {
                el.style.backgroundImage = el.style.backgroundImage.replace(
                    '100x100',
                    '250x250',
                );
            });
    };

    const addLightboxToProducts = (component) => {
        const elements = [];

        const links = component.view.wrapper.querySelectorAll(
            '.shopify-buy__carousel a',
        );

        if (
            links.length === 1 &&
            lightboxInitted.indexOf(component.model.id) > -1
        ) {
            // This is a weird case where the click listener gets bound multiple times to single image products,
            // this fixes that.
            return;
        }

        const mainImage =
            links.length > 1
                ? component.view.wrapper.querySelector(
                      '.main-image-wrapper img',
                  )
                : component.view.wrapper.querySelector(
                      '.shopify-buy__product-img-wrapper img',
                  );

        links.forEach((anchor) => {
            elements.push({
                href: anchor.href,
                type: 'image',
                alt: anchor.ariaLabel,
            });
        });

        const imageGallery = GLightbox({
            elements,
        });

        imageGallery.on('slide_changed', (e) => {
            links[e.current.index].click();
        });

        const clickListener = (e) => {
            const selectedIndex = [...links].findIndex((a) =>
                a.classList.contains('shopify-buy__carousel-item--selected'),
            );

            imageGallery.openAt(selectedIndex);
        };

        mainImage.addEventListener('click', clickListener);

        lightboxInitted.push(component.model.id);
    };

    var scriptURL =
        'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
            ShopifyBuyInit();
        } else {
            loadScript();
        }
    } else {
        loadScript();
    }
    function loadScript() {
        var script = document.createElement('script');
        script.async = true;
        script.src = scriptURL;
        (
            document.getElementsByTagName('head')[0] ||
            document.getElementsByTagName('body')[0]
        ).appendChild(script);
        script.onload = ShopifyBuyInit;
    }
    function ShopifyBuyInit() {
        var client = ShopifyBuy.buildClient({
            domain: 'built-for-the-stage.myshopify.com',
            storefrontAccessToken: 'af19b875a993f732552c99cc0fb122ab',
        });
        ShopifyBuy.UI.onReady(client).then(function (ui) {
            const buttonStyles = {
                'font-family': 'Bebas Neue, sans-serif',
                ':hover': {
                    'background-color': 'rgb(31, 41, 55)',
                },
                'background-color': '#000',
                ':focus': {
                    'background-color': '#000',
                },
                'font-size': '1.5rem',
                'border-radius': 0,
            };

            ui.createComponent('collection', {
                id: '235420975263',
                node: document.getElementById(
                    'collection-component-1611264985605',
                ),
                moneyFormat: '%24%7B%7Bamount%7D%7D',
                options: {
                    product: {
                        order: [
                            'img',
                            'imgWithCarousel',
                            'title',
                            'price',
                            'description',
                            'options',
                            'button',
                        ],
                        contents: {
                            imgWithCarousel: true,
                            description: true,
                        },
                        events: {
                            beforeRender: (component) => {
                                try {
                                    if (!component.selectedVariant.available) {
                                        const inStock =
                                            component.model.variants.find(
                                                (variant) => variant.available,
                                            );

                                        if (inStock) {
                                            component.updateVariant(
                                                inStock.selectedOptions[0].name,
                                                inStock.title,
                                            );
                                        }
                                    }
                                } catch (e) {
                                    console.error(e);
                                }

                                const shopifyLoading =
                                    document.getElementById('shopify-loading');

                                if (shopifyLoading) {
                                    shopifyLoading.remove();
                                }
                            },
                            afterRender: (component) => {
                                fixCarouselElement(component);
                                addLightboxToProducts(component);

                                window.dispatchEvent(new Event('resize'));

                                const perPage = 20;

                                const nodeCount =
                                    component.node.querySelectorAll(
                                        '.shopify-buy__product',
                                    ).length;

                                const page = Math.ceil(nodeCount / perPage);

                                nextPage(page, component);
                            },
                        },
                        styles: {
                            product: {
                                '@media (min-width: 601px)': {
                                    'max-width': 'calc(50% - 40px)',
                                    'margin-left': '40px',
                                    'margin-bottom': '50px',
                                    width: 'calc(50% - 40px)',
                                },
                                img: {
                                    height: 'calc(100% - 15px)',
                                    position: 'absolute',
                                    left: '0',
                                    right: '0',
                                    top: '0',
                                },
                                imgWrapper: {
                                    'padding-top': 'calc(75% + 15px)',
                                    position: 'relative',
                                    height: '0',
                                },
                                options: {
                                    'margin-top': '24px',
                                },
                            },
                            title: {
                                'font-family': 'Roboto, sans-serif',
                                'font-weight': 'normal',
                            },
                            button: buttonStyles,
                            price: {
                                'font-family': 'Roboto, sans-serif',
                            },
                            compareAt: {
                                'font-family': 'Roboto, sans-serif',
                            },
                            unitPrice: {
                                'font-family': 'Roboto, sans-serif',
                            },
                        },
                        text: {
                            button: 'Add to cart',
                            outOfStock: 'Size Currently Out of Stock',
                        },
                        googleFonts: ['Bebas Neue', 'Roboto'],
                    },
                    productSet: {
                        styles: {
                            products: {
                                '@media (min-width: 601px)': {
                                    'margin-left': '-40px',
                                },
                            },
                        },
                    },
                    modalProduct: {
                        contents: {
                            img: false,
                            imgWithCarousel: true,
                            button: false,
                            buttonWithQuantity: true,
                            description: true,
                        },
                        styles: {
                            product: {
                                '@media (min-width: 601px)': {
                                    'max-width': '100%',
                                    'margin-left': '0px',
                                    'margin-bottom': '0px',
                                },
                            },
                            button: {
                                'font-family': 'Roboto, sans-serif',
                                ':hover': {
                                    'background-color': '#3575dd',
                                },
                                'background-color': '#3b82f6',
                                ':focus': {
                                    'background-color': '#3575dd',
                                },
                            },
                        },
                        googleFonts: ['Roboto'],
                        text: {
                            button: 'Add to cart',
                        },
                    },
                    option: {
                        styles: {
                            label: {
                                'font-family': 'Roboto, sans-serif',
                            },
                            select: {
                                'font-family': 'Roboto, sans-serif',
                            },
                        },
                        googleFonts: ['Roboto'],
                    },
                    cart: {
                        styles: {
                            button: buttonStyles,
                        },
                        text: {
                            total: 'Subtotal',
                            button: 'Checkout',
                            notice: 'Shipping and discount codes are added at checkout. There are no refunds for products purchased. You may exchange an item with a store credit from your purchase.',
                        },
                        googleFonts: ['Roboto'],
                    },
                    toggle: {
                        styles: {
                            toggle: {
                                'font-family': 'Roboto, sans-serif',
                                'background-color': '#000',
                                ':hover': {
                                    'background-color': 'rgb(31, 41, 55)',
                                },
                                ':focus': {
                                    'background-color': 'rgb(31, 41, 55)',
                                },
                            },
                        },
                        googleFonts: ['Roboto'],
                    },
                },
            });
        });
    }
})();
